/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  accessAPI,
  formatFecha,
  Boton,
  Titulo,
  CampoInformacion,
  Formulario, tituloBase, useFuncionalidad } from "../../../../shared";

import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";
import { Sidebar, TablaFiltrable } from "../../../../shared";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

export default function HallazgoTipo() {
  // La configuración de reportes a DNI solo para organismos con la integración
  const conJuguetesDni = useFuncionalidad("JUGUETES_DNI");
  const [hallazgoTipo, setHallazgoTipo] = useState(null);
  const [sidebarEditar, setSidebarEditar] = useState(false);
  const [loaderEditar, setLoaderEditar] = useState(false);
  const [loaderDeshabilitarHabilitar, setLoaderDeshabilitarHabilitar] =
    useState(false);
  const { hallazgoTipoId } = useParams();
  const toast = useRef(null);

  useEffect(() => {
    cargarHallazgoTipo();
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function cargarHallazgoTipo() {
    accessAPI(
      "GET",
      `admin/hallazgo/tipo/${hallazgoTipoId}`,
      null,
      (respuesta) => {
        setHallazgoTipo(respuesta);
        document.title = respuesta.nombre;
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al cargar el tipo de hallazgo",
          sticky: true
        });
      }
    );
  }

  function editarHallazgoTipoSubmit(respuestasFormulario) {
    // "Requiere análisis" y "Permite archivos" exigen "Cliente responde" (la
    // API también lo valida)
    if ((respuestasFormulario.requiereAnalisis || respuestasFormulario.permiteArchivos) && !respuestasFormulario.clienteResponde) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Para que el tipo requiera análisis o permita archivos, el cliente tiene que responder.",
        sticky: true
      });
      return;
    }
    setLoaderEditar(true);
    accessAPI(
      "PUT",
      `admin/hallazgo/tipo/${hallazgoTipoId}`,
      respuestasFormulario,
      (respuesta) => {
        setHallazgoTipo(respuesta);
        document.title = respuesta.nombre;
        setSidebarEditar(false);
        setLoaderEditar(false);
        toast.current?.show({
          severity: "success",
          summary: "Actualizado",
          detail: "Tipo de hallazgo actualizado exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg ||
            "Error al actualizar el tipo de hallazgo",
          sticky: true
        });
        setLoaderEditar(false);
      }
    );
  }

  function toggleActiva() {
    const accion = hallazgoTipo.activa ? "Deshabilitar" : "Habilitar";
    confirmDialog({
      message: `¿${accion} el tipo de hallazgo "${hallazgoTipo.nombre}"?`,
      header: `Confirmar ${accion.toLowerCase()}`,
      icon: "pi pi-exclamation-triangle",
      acceptLabel: accion,
      rejectLabel: "Cancelar",
      acceptClassName: hallazgoTipo.activa
        ? "p-button-danger"
        : "p-button-success",
      accept: () => {
        setLoaderDeshabilitarHabilitar(true);
        accessAPI(
          "PUT",
          `admin/hallazgo/tipo/${hallazgoTipo.id}`,
          { ...hallazgoTipo, activa: !hallazgoTipo.activa },
          (respuesta) => {
            setLoaderDeshabilitarHabilitar(false);
            setHallazgoTipo(respuesta);
            toast.current?.show({
              severity: "success",
              summary: accion === "Deshabilitar" ? "Deshabilitado" : "Habilitado",
              detail: `Tipo de hallazgo ${accion.toLowerCase()}do`
            });
          },
          (respuesta) => {
            setLoaderDeshabilitarHabilitar(false);
            toast.current?.show({
              severity: "error",
              summary: "Error",
              detail:
                respuesta[0]?.msg ||
                `Error al ${accion.toLowerCase()} el tipo de hallazgo`,
              sticky: true
            });
          }
        );
      }
    });
  }

  const deshabilitado = hallazgoTipo && !hallazgoTipo.activa;
  const tieneHallazgosSinCerrar = hallazgoTipo?._count?.hallazgos > 0;

  const editarFormConfig = hallazgoTipo
    ? {
        secciones: [
          {
            campos: [
              {
                nombre: "nombre",
                tipoitemformularioid: 1,
                etiqueta: "Nombre",
                requerido: true,
                respuesta: hallazgoTipo.nombre
              },
              {
                nombre: "clienteResponde",
                tipoitemformularioid: 6,
                etiqueta: "Cliente responde",
                respuesta: hallazgoTipo.clienteResponde
              },
              {
                nombre: "requiereAnalisis",
                tipoitemformularioid: 6,
                etiqueta: "Requiere análisis",
                respuesta: hallazgoTipo.requiereAnalisis
              },
              {
                nombre: "permiteArchivos",
                tipoitemformularioid: 6,
                etiqueta: "Permite archivos",
                respuesta: hallazgoTipo.permiteArchivos
              },
              ...(conJuguetesDni
                ? [
                    {
                      nombre: "enviarDNIJuguetes",
                      tipoitemformularioid: 6,
                      etiqueta: "Reportar a DNI - producto",
                      respuesta: hallazgoTipo.enviarDNIJuguetes
                    },
                    {
                      nombre: "enviarDNIJuguetesInspeccion",
                      tipoitemformularioid: 6,
                      etiqueta: "Reportar a DNI - inspección",
                      respuesta: hallazgoTipo.enviarDNIJuguetesInspeccion
                    }
                  ]
                : [])
            ]
          }
        ],
        botones: [
          {
            etiqueta: "Guardar cambios",
            callback: editarHallazgoTipoSubmit,
            validar: true
          }
        ]
      }
    : null;

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <ConfirmDialog />

      {!hallazgoTipo && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "1em"
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div css={{ display: "flex", alignItems: "center", gap: "1em" }}>
              <Skeleton width="2rem" height="2rem" shape="circle" />
              <Skeleton width="15rem" height="2rem" />
            </div>
          </div>
          <Card>
            <Skeleton
              width="6rem"
              height="1.5rem"
              css={{ marginBottom: "1.5em" }}
            />
            <div className="grid">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="col-12 md:col-4">
                  <Skeleton
                    width="50%"
                    height="0.8rem"
                    css={{ marginBottom: "0.5rem" }}
                  />
                  <Skeleton width="80%" height="1.2rem" />
                </div>
              ))}
            </div>
          </Card>
        </div>
      )}

      {hallazgoTipo && (
        <>
          <Titulo
            urlVolver="/hallazgotipo"
            etiquetas={
              deshabilitado ? [{ texto: "Deshabilitado", error: true }] : []
            }
            botones={
              hallazgoTipo.activa ? (
                <Boton
                  rojo
                  transparente
                  callback={toggleActiva}
                  loader={loaderDeshabilitarHabilitar}
                >
                  Deshabilitar
                </Boton>
              ) : (
                <Boton
                  verde
                  transparente
                  callback={toggleActiva}
                  loader={loaderDeshabilitarHabilitar}
                >
                  Habilitar
                </Boton>
              )
            }
          >
            {hallazgoTipo.nombre}
          </Titulo>

          <Card>
            <Titulo
              botones={
                <Boton icono negro callback={() => setSidebarEditar(true)}>
                  <i className="pi pi-pencil" />
                </Boton>
              }
            >
              Detalles
            </Titulo>
            <div className="grid">
              <CampoInformacion nombreCampo="Nombre">
                {hallazgoTipo.nombre}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Cliente Responde">
                {hallazgoTipo.clienteResponde ? "Sí" : "No"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Requiere análisis">
                {hallazgoTipo.requiereAnalisis ? "Sí" : "No"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Permite archivos">
                {hallazgoTipo.permiteArchivos ? "Sí" : "No"}
              </CampoInformacion>
              {conJuguetesDni && (
                <>
                  <CampoInformacion nombreCampo="Reportar a DNI - producto">
                    {hallazgoTipo.enviarDNIJuguetes ? "Sí" : "No"}
                  </CampoInformacion>
                  <CampoInformacion nombreCampo="Reportar a DNI - inspección">
                    {hallazgoTipo.enviarDNIJuguetesInspeccion ? "Sí" : "No"}
                  </CampoInformacion>
                </>
              )}
            </div>
          </Card>

          {tieneHallazgosSinCerrar && (
            <Card css={{ marginTop: "1em" }}>
              <Titulo>
                Hallazgos sin cerrar ({hallazgoTipo._count.hallazgos})
              </Titulo>
              <TablaFiltrable conFiltros={false}
                value={hallazgoTipo.hallazgos}
                nombreArchivo="hallazgos_sin_cerrar"
                emptyMessage="No hay hallazgos sin cerrar"
                stripedRows
                paginator
                rows={10}
              >
                <Column
                  header="Texto"
                  body={(rowData) => (
                    <span
                      css={{
                        display: "inline-block",
                        maxWidth: "300px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap"
                      }}
                    >
                      {rowData.texto}
                    </span>
                  )}
                />
                <Column
                  header="Auditor Creador"
                  body={(rowData) =>
                    rowData.auditorCreador
                      ? `${rowData.auditorCreador.nombre} ${rowData.auditorCreador.apellido}`
                      : "-"
                  }
                />
                <Column
                  header="Proceso"
                  body={(rowData) => {
                    const proceso =
                      rowData.actividadPaso?.actividad?.proceso;
                    if (!proceso) return "-";
                    return proceso.nombre || "-";
                  }}
                />
                <Column
                  header="Fecha Creación"
                  body={(rowData) => formatFecha(rowData.fechaCreacion)}
                  style={{ width: "10rem" }}
                />
              </TablaFiltrable>
            </Card>
          )}

          <Sidebar
            visible={sidebarEditar}
            position="right"
            onHide={() => setSidebarEditar(false)}
            className="w-full lg:w-30rem md:w-30rem"
          >
            <Titulo>Editar tipo de hallazgo</Titulo>
            {editarFormConfig && (
              <Formulario
                key={hallazgoTipo.id + "-" + hallazgoTipo.nombre}
                config={editarFormConfig}
                loader={loaderEditar}
              />
            )}
          </Sidebar>
        </>
      )}
    </>
  );
}
